// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__wJ5jp","content":"Contact_content__rnf9O","info":"Contact_info__4M3u9","input":"Contact_input__p1kjg","submit":"Contact_submit__W+zbC"};